import React from 'react';
import { motion } from 'framer-motion';
import { Check, Globe, Lock, Shield, Sparkles, Zap } from 'lucide-react';
import { Button } from './Button';
function track(name: string, value: number) {
  window.fbq?.('track', 'InitiateCheckout', {
    content_name: name,
    value,
    currency: 'USD'
  });
}
const includes = ['Todo lo del Mega Pack Historia 360 (8 tomos + 4 bonos)', 'Mesopotamia y el nacimiento de la civilización — profundidad real', 'Egipto, India, China y pueblos del Mediterráneo oriental', 'Grecia antigua y Roma — desde la polis hasta la caída del Imperio', 'Edad Media, Renacimiento y Reforma religiosa', 'Ilustración, Revoluciones atlánticas e Industrialización', 'Imperialismo y caja final de herramientas docentes avanzadas'];
export function PricingSection() {
  return <section id="pricing" className="bg-white px-4 py-20" data-id="element-130" data-mp="2vqrhc036cwk">
      <div className="mx-auto max-w-3xl" data-id="element-131" data-mp="7ts9dtls066g">
        <header className="mb-12 text-center" data-id="element-132" data-mp="7utjnvuywon4">
          <h2 className="font-serif text-4xl font-bold text-navy" data-id="element-133" data-mp="7vmup90ym0b2">
            Elige tu pack
          </h2>
          <p className="mt-2 text-gold-dark" data-id="element-134" data-mp="1hpy97xpcd6pn">
            Dos opciones · Mismo acceso inmediato
          </p>
        </header>
        <PriceCard label="OFERTA PRINCIPAL" name="Mega Pack Historia 360" desc="Los 8 tomos + 4 bonos estratégicos listos para usar en el aula." old="USD 55,00" price="USD 17,90" url="https://ktdgr0-mw.myshopify.com/cart/48182459236570:1" value={17.9} data-id="element-135" data-mp="1cq3ipv9haj54" />
        <motion.article initial={{
        opacity: 0,
        y: 22
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative mt-9 rounded-3xl border border-gold/60 bg-white p-1 shadow-[0_10px_28px_rgba(16,42,67,.1)]" data-id="element-136" data-mp="20gz7ejin0y85">
          <div className="absolute -top-4 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full bg-[#F4E6C3] px-5 py-1.5 text-xs font-bold text-gold-dark" data-id="element-137" data-mp="g0cm9qhmmlwo">
            <Sparkles size={13} data-id="element-138" data-mp="mhe81chgqnyl" /> MÁS ELEGIDO · MEJOR VALOR
          </div>
          <div className="rounded-[1.3rem] bg-[#FFFCF5] p-7 text-center sm:p-10" data-id="element-139" data-mp="mei5tbyl1d4c">
            <h3 className="font-serif text-2xl font-bold text-navy" data-id="element-140" data-mp="7lohr258voo2">
              Mega Pack Historia 360 + Pack Maestro Avanzado
            </h3>
            <p className="my-4 text-ink" data-id="element-141" data-mp="3uwedie5synrp">
              El pack completo más material que profundiza los períodos más
              enseñados en el aula.
            </p>
            <ul className="mx-auto mb-6 max-w-md space-y-2 rounded-xl bg-white p-4 text-left shadow-sm" data-id="element-142" data-mp="3kyi4pt0c84wr">
              {includes.map(item => <li className="flex gap-2 text-sm text-ink" key={item} data-id="element-143" data-mp="3pycv7vg7asha">
                  <Check size={16} className="shrink-0 text-green" data-id="element-144" data-mp="3bxa7zfdgzc4s" />
                  {item}
                </li>)}
            </ul>
            <s className="block text-slate-400" data-id="element-145" data-mp="3fylzxrjtg9g5">USD 82,90</s>
            <p className="my-2 text-4xl font-bold text-navy" data-id="element-146" data-mp="2xabihpy6arsp">USD 24,90</p>
            <Button target="_blank" href="https://ktdgr0-mw.myshopify.com/cart/48182509175002:1" onLinkClick={() => track('Mega Pack Historia 360 + Pack Maestro Avanzado', 24.9)} className="mt-3 w-full sm:w-auto" data-id="element-147" data-mp="2sc0alkrfurd4">
              LLEVAR EL PACK COMPLETO
            </Button>
            <p className="mt-5 flex items-start gap-2 rounded-xl bg-white p-3 text-left text-xs text-slate-600 shadow-sm" data-id="element-148" data-mp="3g7uu91c0moit">
              <Globe size={15} className="shrink-0 text-gold" data-id="element-149" data-mp="3p29g5mr1wxaw" />
              Pagas en tu moneda local. El importe se adapta automáticamente a
              tu país.
            </p>
          </div>
        </motion.article>
      </div>
    </section>;
}
function PriceCard({
  label,
  name,
  desc,
  old,
  price,
  url,
  value
}: {
  label: string;
  name: string;
  desc: string;
  old: string;
  price: string;
  url: string;
  value: number;
}) {
  return <motion.article initial={{
    opacity: 0,
    y: 22
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="relative rounded-3xl border border-slate-200 bg-white p-1 shadow-[0_8px_24px_rgba(16,42,67,.08)]" data-id="element-150" data-mp="hxkt2c6jy4x3">
      <span className="absolute -top-4 left-1/2 -translate-x-1/2 rounded-full bg-[#E7F5EA] px-5 py-1.5 text-xs font-bold text-green-dark" data-id="element-151" data-mp="vopof22w0b1m">
        {label}
      </span>
      <div className="rounded-[1.3rem] bg-mist p-7 text-center sm:p-10" data-id="element-152" data-mp="31v1zzmif1li">
        <h3 className="font-serif text-2xl font-bold text-navy" data-id="element-153" data-mp="7zdfm3bh24zu">{name}</h3>
        <p className="my-5 text-ink" data-id="element-154" data-mp="829a1ho42bjj">{desc}</p>
        <s className="text-slate-400" data-id="element-155" data-mp="d011kakufvn7">{old}</s>
        <p className="my-2 text-4xl font-bold text-navy" data-id="element-156" data-mp="cwn1xa3ke0jg">{price}</p>
        <Button target="_blank" href={url} onLinkClick={() => track(name, value)} className="mt-3 w-full sm:w-auto" data-id="element-157" data-mp="1jejwl6c9hbfj">
          QUIERO EL MEGA PACK
        </Button>
        <div className="mt-5 flex flex-wrap justify-center gap-4 text-xs text-slate-600" data-id="element-158" data-mp="38vfesv19vf43">
          <span data-id="element-159" data-mp="33xm9e47smp4v">
            <Lock className="mr-1 inline text-green" size={13} data-id="element-160" data-mp="33z73xtu3y82q" />
            Pago seguro
          </span>
          <span data-id="element-161" data-mp="2z41c6ee0xz6q">
            <Zap className="mr-1 inline text-green" size={13} data-id="element-162" data-mp="2u7km3en9lar0" />
            Acceso inmediato
          </span>
          <span data-id="element-163" data-mp="2q68uj3ktyfg6">
            <Shield className="mr-1 inline text-green" size={13} data-id="element-164" data-mp="2q6qykmdqhxyn" />
            Garantía 7 días
          </span>
        </div>
      </div>
    </motion.article>;
}